import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { CONFIG } from '../config';

/**
 * In-app Swagger UI over the JWT-gated OpenAPI spec (/api/openapi.json).
 * The session token authenticates both the spec fetch and Try-it-out calls,
 * so the docs are live-executable with the chart login. swagger-ui-dist is
 * dynamically imported to keep its JS/CSS out of the main bundle.
 */
export default function ApiDocsPage() {
  const containerRef = useRef(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let ui = null;
    let cancelled = false;

    (async () => {
      try {
        const [{ default: SwaggerUIBundle }] = await Promise.all([
          import('swagger-ui-dist/swagger-ui-bundle'),
          import('swagger-ui-dist/swagger-ui.css'),
        ]);
        if (cancelled || !containerRef.current) return;
        ui = SwaggerUIBundle({
          domNode: containerRef.current,
          url: `${CONFIG.apiUrl}/api/openapi.json`,
          requestInterceptor: (req) => {
            const token = localStorage.getItem('auth_token');
            if (token) req.headers['Authorization'] = `Bearer ${token}`;
            return req;
          },
          presets: [SwaggerUIBundle.presets.apis],
          docExpansion: 'list',
          deepLinking: false,
          defaultModelsExpandDepth: 0,
          displayRequestDuration: true,
        });
      } catch (e) {
        if (!cancelled) setError(String(e));
      }
    })();

    return () => {
      cancelled = true;
      // Swagger UI has no destroy API; clearing the node drops its DOM.
      ui = null;
      if (containerRef.current) containerRef.current.innerHTML = '';
    };
  }, []);

  return (
    <div style={{ minHeight: '100vh', background: '#0a0e1a', padding: '12px 16px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 10 }}>
        <Link to="/chart" className="nav-link" style={{ color: '#8ab4ff', textDecoration: 'none' }}>
          &larr; Chart
        </Link>
        <span style={{ color: '#e0e0e0', fontWeight: 600 }}>API Reference</span>
        <span style={{ color: '#667', fontSize: 12 }}>
          Requests run with your chart session token
        </span>
      </div>
      {error && (
        <div style={{ color: '#ff6b6b', padding: 12 }}>
          Failed to load API docs: {error}
        </div>
      )}
      {/* Swagger UI is light-themed: host it on a light card */}
      <div ref={containerRef} style={{ background: '#fff', borderRadius: 8, padding: 8 }} />
    </div>
  );
}
